import moment from "moment";

export class Recording {
  constructor(
    public id: number,
    public recordingJobId: string,
    public sourceId: string,
    public startTime: moment.Moment,
    public associatedMediaId: number,
    public status: RecordingStatus,
  ) {}
}

export enum RecordingStatus {
  Created = -1,
  Idle = 0,
  Ready,
  Starting,
  Recording,
  Stopped,
  Error,
  MetadataReady,
}
